import React, {useEffect, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/BusinessTypesPopupLink';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";

const BusinessTypesRegistrator = props => {
  // propsの初期値はnullのため、nullの場合はから配列をセットする
  const [businessTypes, setBusinessTypes] = useState((()=>{
    if (props.business_types == null) {
      return [];
    } else {
      // 再表示時（エラー発生時）に帰ってくるid値がstring型なので、number型に変換する
      return props.business_types.map(businessType => {
        businessType.id = Number(businessType.id);
        return businessType;
      });
    }
  })());
  // ie. "1,2,3"
  const [businessTypeIds, setBusinessTypeIds] = useState(props.business_types_ids || businessTypes.map(sBT => sBT.id).join());

  useEffect(() => {
    // businessTypes更新時にIdsも更新する
    setBusinessTypeIds(businessTypes.map(sBT => sBT.id).join());
  }, [businessTypes]);

  const url = (() => {
    const path = '/popup/member_business_types';
    const data = {
      selected_ids: businessTypes.map(bT => bT.id),
      is_limited_item: 1
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedBusinessTypes => {
    // BusinessTypes特有の属性であるlengthとdetailを空で追加する
    // これを行わないと各値がundefinedになるため、Reactがcontrolできなくなってしまう。
    selectedBusinessTypes.map(sBT => {
      sBT.length = "";
      sBT.detail = "";
    });
    // 業種・職種の詳細情報{経験年数: length, 仕事内容: detail}が
    // ユーザ入力時に新要素としてmember_business_typesに追加される
    // set時にselectedBusinessTypesに上記要素を追加する必要がある
    const newBusinessTypes = [...selectedBusinessTypes];
    let count = 0;
    for (let selectedBType of selectedBusinessTypes) {
      for (let prevBType of businessTypes) {
        if (selectedBType.id === Number(prevBType.id)) {
          newBusinessTypes[count] = {...prevBType};
        }
      }
      count++;
    }

    setBusinessTypes(newBusinessTypes);
  };

  const onChangeBusinessTypeIds = event => {
    setBusinessTypeIds(event.target.value);
  };

  const onChangeDetailComponent = details => {
    const changedBusinessTypes = businessTypes.map(businessType => {
      if (businessType.id === details.id) {
        businessType = details;
      }
      return businessType;
    });
    setBusinessTypes(changedBusinessTypes);
  };

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.businessTypes}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_industry')}
        onClosePopup={onClosePopup}
        selectedNames={businessTypes.map(bT => bT.name).join("/")}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}
      />
      <input id="search_business_type_ids"
             type="hidden"
             name="associate_member[business_types_ids]"
             onChange={onChangeBusinessTypeIds}
             value={businessTypeIds}
      />
      <DetailList businessTypes={businessTypes}
                  business_types_length_errors={props.business_types_length_errors}
                  business_types_detail_errors={props.business_types_detail_errors}
                  onChangeDetailComponent={onChangeDetailComponent}
      />
    </>
  );
};

BusinessTypesRegistrator.propTypes = {
  business_types: PropTypes.arrayOf(
    PropTypes.object,
  ),
  business_types_length_errors: PropTypes.arrayOf(
    PropTypes.string
  ),
  business_types_detail_errors: PropTypes.arrayOf(
    PropTypes.string
  ),
  business_types_ids: PropTypes.string,
  input_industry_name: PropTypes.string,
  LinkForPopup: PropTypes.node,
};


const DetailList = props => {
  const onChangeId = (e, details) => {
    details.id = e.target.value;
    props.onChangeDetailComponent(details);
  };
  const onChangeName = (e, details) => {
    details.name = e.target.value;
    props.onChangeDetailComponent(details);
  };
  const onChangeLength = (e, details) => {
    details.length = e.target.value;
    props.onChangeDetailComponent(details);
  };
  const onChangeDetail = (e, details) => {
    details.detail = e.target.value;
    props.onChangeDetailComponent(details);
  };

  return props.businessTypes.map((businessType, index) => {
    return (
      <div key={index} className="business_type_item business_block">
        <span className="business_type_name">{businessType.name}</span>
        <input className="business_types"
               type="hidden"
               name="associate_member[business_types][][id]"
               onChange={e => onChangeId(e, businessType)}
               value={businessType.id}
        />
        <input className="business_type_input"
               type="hidden"
               name="associate_member[business_types][][name]"
               onChange={e => onChangeName(e, businessType)}
               value={businessType.name}
        />
        {
          props.business_types_length_errors[index] &&
          <div className="error_massage">{"経験年数" + props.business_types_length_errors[index]}</div>
        }
        <p className="font_m fs-88">＜経験年数＞<br/>
          <input type="text"
                 className="w10 business_length business_length_sp"
                 name="associate_member[business_types][][length]"
                 min="1"
                 maxLength="2"
                 onChange={e => onChangeLength(e, businessType)}
                 value={businessType.length}
          />&nbsp;年</p>
        {
          props.business_types_detail_errors[index] &&
        <div className="error_massage">{ "仕事内容" + props.business_types_detail_errors[index]}</div>
        }
        <p className="font_m fs-88">＜仕事内容＞<br/>
          <input type="text"
                 className="w100 business_detail"
                 name="associate_member[business_types][][detail]"
                 maxLength="100"
                 onChange={e => onChangeDetail(e, businessType)}
                 value={businessType.detail}
          />
        </p>
        <hr/>
      </div>
    );
  });
};
DetailList.propTypes = {
  businessType: PropTypes.object,
  business_types_length_errors: PropTypes.arrayOf(
    PropTypes.string
  ),
  business_types_detail_errors: PropTypes.arrayOf(
    PropTypes.string
  ),
  onChangeDetailComponent: PropTypes.func,
};

const ButtonArea = props => {
  return <a className="select select-industry-btn" onClick={props.onClickCloseButton}>選択</a>
};

export default BusinessTypesRegistrator;
